import { Sites } from '@ps/platform-message-framework/common/Sites';
import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import fsbIcon from '@swf/core/assets/casino/free-spins.png';
import ArrowIcon from '@swf/core/assets/icons/arrow.svg';
import { select } from '@swf/core/store';
import type { PrizeDetail } from '@swf/core/types/CasinoRaces';
import { PrizeType } from '@swf/core/types/CasinoRaces';

import {
  TXTMOB_Prize_Information,
  TXTWCL_Reward_Information,
  TXTWCL_Valid_ForXXbXN0_daysX_bX
} from './PrizeInfo.messages.json';
import styles from './PrizeInfo.scss';
import cashIcon from './assets/cash-icon.png';
import cashImage from './assets/cash.png';
import fsbImage from './assets/fs.png';
import ibIconOld from './assets/ib-icon.png';
import ibImage from './assets/ib.png';
import Description from './components/Description/Description';
import PaidInfo from './components/PaidInfo/PaidInfo';
import Title from './components/Title/Title';

const prizeIconsOld = {
  [PrizeType.IB]: ibIconOld,
  [PrizeType.CASH]: cashIcon,
  [PrizeType.FSB]: fsbIcon
};

const prizeImages = {
  [PrizeType.IB]: ibImage,
  [PrizeType.CASH]: cashImage,
  [PrizeType.FSB]: fsbImage
};

interface Props {
  prizeDetails: PrizeDetail;
}

const PrizeInfo: React.FC<Props> = (props) => {
  const { prizeDetails } = props;
  const [expanded, toggleExpanded] = useState(false);
  const site = useSelector(select.cms.getSiteId);
  const siteIT = site === Sites.ITA;

  return (
    <div
      className={classNames(styles.legacy, styles.prizeInfo)}
      onClick={() => toggleExpanded(!expanded)}
    >
      {!expanded ? (
        <div className={styles.prizeShort}>
          <div className={styles.prizeIconHolder}>
            <img
              className={styles.prizeIcon}
              src={prizeIconsOld[prizeDetails.prizeType as keyof typeof prizeIconsOld]}
              alt=""
            />
          </div>
          <div className={styles.prizeStub}>
            <div className={styles.prizeTitle}>
              {
                <Translation
                  {...(prizeDetails.prizeType === PrizeType.CASH && siteIT
                    ? TXTWCL_Reward_Information
                    : TXTMOB_Prize_Information)}
                />
              }
            </div>
            <div className={styles.prizeArrow}>
              <ArrowIcon />
            </div>
            <div className={styles.prizeDesc}>
              <Description prizeDetails={prizeDetails} />
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.prizeLong}>
          <div className={styles.prizeHeader}>
            <div className={styles.prizeTitle}>
              {
                <Translation
                  {...(prizeDetails.prizeType === PrizeType.CASH && siteIT
                    ? TXTWCL_Reward_Information
                    : TXTMOB_Prize_Information)}
                />
              }
            </div>
            <div className={styles.prizeArrow}>
              <ArrowIcon />
            </div>
          </div>
          <div
            className={classNames(
              styles.prizeBodyOld,
              [PrizeType.CASH, PrizeType.ZERO].includes(prizeDetails.prizeType) && styles.prizeCash
            )}
          >
            <div className={styles.prizeBigIcon}>
              <img
                className={styles.prizeBigIcon}
                src={prizeImages[prizeDetails.prizeType as keyof typeof prizeImages]}
                alt=""
              />
            </div>
            <div className={styles.prizeTitle}>
              <Title prizeDetails={prizeDetails} />
            </div>
            <div className={styles.prizeDesc}>
              <Description prizeDetails={prizeDetails} showFull />
            </div>
            <div className={classNames(styles.prizeStatsOld, styles.newLineForBold)}>
              <div>
                <PaidInfo prizeDetails={prizeDetails} />
              </div>
              <div>
                <Translation {...TXTWCL_Valid_ForXXbXN0_daysX_bX} values={{ 0: 7 }} />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PrizeInfo;
